import { render, staticRenderFns } from "./YhContract.vue?vue&type=template&id=3dd2b3a0&scoped=true"
import script from "./YhContract.vue?vue&type=script&lang=js"
export * from "./YhContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2b3a0",
  null
  
)

export default component.exports